export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "data.worker.faa0d6764d68eed0690c.worker.js");
}
